import React from 'react';
import SideNavItem from 'factory/sidenav/components/SideNavItem';
import AddonsSideNavItem from 'factory/sidenav/components/AddonsSideNavItem';
import SideNavContent from '../factory/sidenav/components/SideNavContent';
import { useQuery } from "@apollo/client/react";
import { notificationsQuery } from '../factory/notification/graphql';
import Auth from '../Auth';

export interface LithoilSideNavProps {
  path: string;
  onSideNavToggle: Function;
}

interface Notification {
  id: number;
  message: string;
  [key: string]: any;
}

const LithoilSideNav: React.FC<LithoilSideNavProps> = ({ path }) => {
  useQuery<{ notifications: Notification[] }>(notificationsQuery, {
    fetchPolicy: 'network-only',
    pollInterval: 60000,
  });

  const isAdmin = Auth.isAdmin();

  return (
    <div>
      <ul className="navigation navigation--light">
        <AddonsSideNavItem />
      </ul>
      <SideNavContent path={path}>
        <SideNavItem link="/dashboard" icon="Graphs" label="dashboard" />
        <SideNavItem link="/reports" icon="Reports" label="reports" />
        <SideNavItem link="/journals" icon="Journal" label="journals" />
        <SideNavItem link="/order/reports" icon="Reports" label="reports.title" />
        {isAdmin && (
          <SideNavItem link="/analytics" icon="Dashboard" label="analytics.title" />
        )}
        {isAdmin && (
          <SideNavItem link="/orders" icon="description" label="orders" />
        )}
        {isAdmin && (
          <SideNavItem
            link="/railway-orders"
            icon="iso"
            label="railwayOrders.title"
            tooltip="railwayOrders.tooltip"
          />
        )}
        {isAdmin && (
          <SideNavItem link="/income-orders" icon="note_add" label="incomeOrders.title" />
        )}
        {isAdmin && (
          <SideNavItem link="/internal-orders" icon="Events" label="internalOrders.title" />
        )}
        {isAdmin && (
          <SideNavItem
            label="administration"
            submenuIcon="Cog"
            link="/settings"
            submenuLabel="administration"
            icon="Cog"
          >
            <ul className="navigation">
              <SideNavItem link="/settings/users" label="users" />
              <SideNavItem link="/settings/companies" label="companies" />
              <SideNavItem link="/settings/materials" label="materials" />
              <SideNavItem link="/settings/drivers" label="drivers" />
              <SideNavItem link="/settings/operators" label="operators" />
              <SideNavItem link="/settings/transports" label="transports.title" />
            </ul>
          </SideNavItem>
        )}
      </SideNavContent>
    </div>
  );
};

export default LithoilSideNav;
